

export default class AuthenticateUtil {

	// 署名
	public static async Sign(
		planetext: string,		// 対象文字列
		privateKey: string		// 秘密鍵(PKCS#1)
	) //: Promise<string> シグネチャ
	{
		// PrivateKey BASE64→バイナリ
		const privateKeyBuf_PKCS1 = AuthenticateUtil.Base64StringToArrayBuffer(privateKey);
		// PrivateKey PKCS#1→PKCS#8
		const privateKeyArrayBuffer = AuthenticateUtil.RSAPKCS1ToRSAPKCS8_PrivKey(privateKeyBuf_PKCS1);
		if (null == privateKeyArrayBuffer) {
			return "";
        }
		const resultPrivateKey = await window.crypto.subtle.importKey(
			"pkcs8",
			privateKeyArrayBuffer,
			{
				name: "RSA-PSS",
				hash: { name: "SHA-256" }
			},
			false,
			["sign"]
		)
		const signature = await window.crypto.subtle.sign(
			{
				name: "RSA-PSS",
				saltLength: 32, //the length of the salt
			},
			resultPrivateKey,
			AuthenticateUtil.StringToArrayBuffer(planetext)
		)
		//returns an ArrayBuffer containing the signature
		const signatureArray = new Uint8Array(signature);
		const signatureText = AuthenticateUtil.ArrayBufferToString(signatureArray);

		return signatureText;
	}

	// 署名検証
	public static async Verify(
		planetext: string,			// 対象文字列
		publicKey: string,			// 公開鍵(PKCS#1)
		signature: string			// シグネチャ
	) //: Promise<boolean> true; 署名OK／false:署名NG
	{
		// PublicKey BASE64→バイナリ
		const publicKeyBuf_PKCS1 = AuthenticateUtil.Base64StringToArrayBuffer(publicKey);
		// PublicKey PKCS#1→PKCS#8
		const publicKeyArrayBuffer = AuthenticateUtil.RSAPKCS1ToRSAPKCS8_PubKey(publicKeyBuf_PKCS1);
		if (null == publicKeyArrayBuffer) {
			return false;
		}
		const signBuf = AuthenticateUtil.Base64StringToArrayBuffer(signature);

		const resultPublicKey = await window.crypto.subtle.importKey(
			"spki",
			publicKeyArrayBuffer,
			{
				name: "RSA-PSS",
				hash: { name: "SHA-256" }
			},
			false,
			["verify"]
		)
		const isvalid = await window.crypto.subtle.verify(
			{
				name: "RSA-PSS",
				saltLength: 32, //the length of the salt
			},
			resultPublicKey,
			signBuf,
			AuthenticateUtil.StringToArrayBuffer(planetext)
		)
		//returns a boolean on whether the signature is true or not
		return isvalid;
	}

	// 秘密鍵 PKCS#1→PKCS#8変換
	public static RSAPKCS1ToRSAPKCS8_PrivKey(
		pkcs1: ArrayBuffer	// PKCS#1
	): ArrayBuffer | null	// PKCS#8
	{
		// https://datatracker.ietf.org/doc/html/rfc5208#appendix-A
		// PrivateKeyInfo ::= SEQUENCE {
		//     version                        Integer,
		//     algorithm                      AlgorithmIdentifier,
		//     privateKey                     OCTET STRING,
		//     [0]  IMPLICIT Attributes       OPTIONAL
		//  }

		const pkcs1Data = new Uint8Array(pkcs1);

		const aaa = new Uint8Array(1);
		aaa[0] = 0;

		const intbuf = AuthenticateUtil.CreateInteger(aaa.buffer);
		if (null == intbuf) {
			return null;
		}
		const VertionASN1 = new Uint8Array(intbuf);

		const rsaAlgId = AuthenticateUtil.CreateRSAAlgorithmIdentifier();
		if (null == rsaAlgId) {
			return null;
		}
		const RSAAlgorithmIdentifierASN1 = new Uint8Array(rsaAlgId);

		const asn1 = AuthenticateUtil.CreateOctetStringASN1(pkcs1Data);
		if (null == asn1) {
			return null;
		}
		const PrivateKeyDataASN1 = new Uint8Array(asn1);

		const verAsn1 = AuthenticateUtil.CreateLengthASN1(VertionASN1.length + RSAAlgorithmIdentifierASN1.length + PrivateKeyDataASN1.length);
		if (null == verAsn1) {
			return null;
		}
		const lengthASN1 = new Uint8Array(verAsn1);

		const pkcs8 = new Uint8Array(1 + lengthASN1.length + VertionASN1.length + RSAAlgorithmIdentifierASN1.length + PrivateKeyDataASN1.length);

		pkcs8.set([0x30], 0);                                                                                            // PrivateKeyInfo ::= SEQUENCE
		pkcs8.set(lengthASN1, 1);
		pkcs8.set(VertionASN1, 1 + lengthASN1.length);                                                                   // version Integer
		pkcs8.set(RSAAlgorithmIdentifierASN1, 1 + lengthASN1.length + VertionASN1.length);                               // algorithm AlgorithmIdentifier
		pkcs8.set(PrivateKeyDataASN1, 1 + lengthASN1.length + VertionASN1.length + RSAAlgorithmIdentifierASN1.length);   // privateKey OCTET STRING

		const AlgorithmIdentifierASN1 = new Uint8Array(15);
		AlgorithmIdentifierASN1.set([0x30, 0x0D, 0x06, 0x09, 0x2A, 0x86, 0x48, 0x86, 0xF7, 0x0D, 0x01, 0x01, 0x01, 0x05, 0x0], 0);

		return pkcs8.buffer;
	}

	// 公開鍵 PKCS#1→PKCS#8変換
	public static RSAPKCS1ToRSAPKCS8_PubKey(
		pkcs1: ArrayBuffer		// PKCS#1
	): ArrayBuffer | null		// PKCS#8
	{
		//  PublicKeyInfo ::= SEQUENCE {
		//      algorithm   AlgorithmIdentifier,
		//      publicKey   BIT STRING
		//  }

		const pkcs1Data = new Uint8Array(pkcs1);

		const asn1 = AuthenticateUtil.CreateRSAAlgorithmIdentifier();
		if (null == asn1) {
			return null;
		}
		const RSAAlgorithmIdentifierASN1 = new Uint8Array(asn1);

		const bitAsn1 = AuthenticateUtil.CreateBitStringASN1(pkcs1Data);
		if (null == bitAsn1) {
			return null;
		}
		const PublicKeyDataASN1 = new Uint8Array(bitAsn1);

		const lenAsn1 = AuthenticateUtil.CreateLengthASN1(RSAAlgorithmIdentifierASN1.length + PublicKeyDataASN1.length);
		if (null == lenAsn1) {
			return null;
		}
		const lengthASN1 = new Uint8Array(lenAsn1);

		const pkcs8 = new Uint8Array(1 + lengthASN1.length + RSAAlgorithmIdentifierASN1.length + PublicKeyDataASN1.length);

		pkcs8.set([0x30], 0);                                                                      // PublicKeyInfo ::= SEQUENCE
		pkcs8.set(lengthASN1, 1);
		pkcs8.set(RSAAlgorithmIdentifierASN1, 1 + lengthASN1.length);                              // algorithm AlgorithmIdentifier
		pkcs8.set(PublicKeyDataASN1, 1 + lengthASN1.length + RSAAlgorithmIdentifierASN1.length);   // publicKey BIT STRING

		return pkcs8.buffer;
	}
	
	// バイナリ→文字列変換
	public static ArrayBufferToString(buf: ArrayBuffer): string {
		const bytes = new Uint8Array(buf);
		let byteText = "";
		for (let i = 0; i < bytes.length; i++) {
			byteText += String.fromCharCode(bytes[i]);
		}
		return window.btoa(byteText);
	}

	// 文字列→バイナリ変換
	public static StringToArrayBuffer(text: string): ArrayBuffer {
		const len = text.length;
		const bytes = new Uint8Array(len);
		for (let i = 0; i < len; i++) {
			bytes[i] = text.charCodeAt(i);
		}
		return bytes.buffer;
	}

	// BASE64文字列→バイナリ変換
	public static Base64StringToArrayBuffer(base64: string): ArrayBuffer {
		const binaryString = window.atob(base64);
		return this.StringToArrayBuffer(binaryString);
	}

	// DER LENGTH
	public static CreateLengthASN1(len: number): ArrayBuffer|null {
		if (128 > len) {
			const bytes = new Uint8Array(1);
			bytes[0] = len;
			return bytes.buffer;
		}
		else if (256 > len) {

			const view = new DataView(new ArrayBuffer(2));
			view.setUint16(0, len, false);
			const bytes = new Uint8Array(view.buffer);
			bytes[0] = 0x81;
			return bytes.buffer;
		}
		else if (256 ** 2 > len) {
			const view = new DataView(new ArrayBuffer(2));
			view.setUint16(0, len, false);
			const length = new Uint8Array(view.buffer);
			const bytes = new Uint8Array(3);
			bytes[0] = 0x82;
			bytes[1] = length[0];
			bytes[2] = length[1];
			return bytes.buffer;
		}
		else if (256 ** 3 > len) {
			const view = new DataView(new ArrayBuffer(4));
			view.setUint32(0, len, false);
			const bytes = new Uint8Array(view.buffer);
			bytes[0] = 0x83;
			return bytes.buffer;
		}
		else if (256 ** 4 > len) {
			const view = new DataView(new ArrayBuffer(4));
			view.setUint32(0, len, false);
			const length = new Uint8Array(view.buffer);
			const bytes = new Uint8Array(5);
			bytes[0] = 0x84;
			bytes[1] = length[0];
			bytes[2] = length[1];
			bytes[3] = length[2];
			bytes[4] = length[3];
			return bytes.buffer;
		}
		return null;
	}

	// NULL
	public static CreateNULL(): ArrayBuffer {
		const NULLASN1 = new Uint8Array([5, 0]);
		return NULLASN1.buffer;
	}

	// INTEGER
	public static CreateInteger(data: ArrayBuffer): ArrayBuffer | null {
		const tempData = new Uint8Array(data);
		const asn1 = AuthenticateUtil.CreateLengthASN1(tempData.length);
		if (null == asn1) {
			return null;
        }
		const lengthDataASN1 = new Uint8Array(asn1);
		const IntegerASN1 = new Uint8Array(1 + lengthDataASN1.length + tempData.length);

		IntegerASN1.set([2], 0);
		IntegerASN1.set(lengthDataASN1, 1);
		IntegerASN1.set(tempData, 1 + lengthDataASN1.length);

		return IntegerASN1.buffer;
	}

	// OBJECT IDENTIFIER
	public static CreateObjectIdentifier(oid: string): ArrayBuffer | null {
		const oids = oid.split(".");
		const oidNumbers = [];
		oidNumbers.push(40 * parseInt(oids[0]) + parseInt(oids[1]));
		for (let i = 2; i < oids.length; ++i) {
			oidNumbers.push(parseInt(oids[i]))
		}

		const oidBytes = [];
		for (const index in oidNumbers) {
			const num = oidNumbers[index];
			let next = num;
			const oidItems = [];
			do {
				oidItems.push(Math.floor(next % 128));

				next = Math.floor(next / 128);

			} while (0 < next);

			for (let i = oidItems.length - 1; 0 <= i; i--) {
				if (i == 0) {
					oidBytes.push(oidItems[i]);
				}
				else {
					oidBytes.push(0x80 | oidItems[i]);
				}
			}
		}

		const asn1 = AuthenticateUtil.CreateLengthASN1(oidBytes.length)
		if (null == asn1) {
			return null;
        }
		const lengthASN1 = new Uint8Array(asn1);
		const ObjectIdentifierASN1 = new Uint8Array(1 + lengthASN1.length + oidBytes.length);

		ObjectIdentifierASN1.set([6], 0);                                           // AlgorithmIdentifier ::= SEQUENCE
		ObjectIdentifierASN1.set(lengthASN1, 1);
		ObjectIdentifierASN1.set(new Uint8Array(oidBytes), 1 + lengthASN1.length);  // algorithm OBJECT IDENTIFIER

		return ObjectIdentifierASN1.buffer;
	}

	// OCTET STRING
	public static CreateOctetStringASN1(data: ArrayBuffer): ArrayBuffer | null {

		const tempData = new Uint8Array(data);
		const asn1 = AuthenticateUtil.CreateLengthASN1(tempData.length);
		if (null == asn1) {
			return null;
        }
		const lengthDataASN1 = new Uint8Array(asn1);
		const OctetStringASN1 = new Uint8Array(1 + lengthDataASN1.length + tempData.length);

		OctetStringASN1.set([4], 0);
		OctetStringASN1.set(lengthDataASN1, 1);
		OctetStringASN1.set(tempData, 1 + lengthDataASN1.length);

		return OctetStringASN1.buffer;
	}

	// BIT STRING
	public static CreateBitStringASN1(data: ArrayBuffer): ArrayBuffer | null {
		const tempData = new Uint8Array(data);
		const asn1 = AuthenticateUtil.CreateLengthASN1(tempData.length + 1);
		if (null == asn1) {
			return null;
        }
		const lengthDataASN1 = new Uint8Array(asn1);
		const BitStringASN1 = new Uint8Array(1 + lengthDataASN1.length + 1 + tempData.length);

		BitStringASN1.set([3], 0);
		BitStringASN1.set(lengthDataASN1, 1);
		BitStringASN1.set([0], 1 + lengthDataASN1.length);			// 余りビット0
		BitStringASN1.set(tempData, 1 + lengthDataASN1.length + 1);

		return BitStringASN1.buffer;
	}

	// RSA ALGORITHM IDENTIFIER
	public static CreateRSAAlgorithmIdentifier(): ArrayBuffer | null {
		// AlgorithmIdentifier ::= SEQUENCE {
		//     algorithm   OBJECT IDENTIFIER,
		//     parameters  ANY DEFINED BY algorithm OPTIONAL
		// }
		const identifer = AuthenticateUtil.CreateObjectIdentifier("1.2.840.113549.1.1.1");
		if (null == identifer) {
			return null;
        }
		const RSAObjectIdentifierASN1 = new Uint8Array(identifer);
		const NULLASN1 = new Uint8Array(this.CreateNULL());

		const asn1 = AuthenticateUtil.CreateLengthASN1(RSAObjectIdentifierASN1.length + NULLASN1.length);
		if (null == asn1) {
			return null;
        }
		const lengthASN1 = new Uint8Array(asn1);

		const AlgorithmIdentifierASN1 = new Uint8Array(1 + lengthASN1.length + RSAObjectIdentifierASN1.length + NULLASN1.length);

		AlgorithmIdentifierASN1.set([0x30], 0);                                                        // AlgorithmIdentifier ::= SEQUENCE
		AlgorithmIdentifierASN1.set(lengthASN1, 1);
		AlgorithmIdentifierASN1.set(RSAObjectIdentifierASN1, 1 + lengthASN1.length);                   // algorithm OBJECT IDENTIFIER
		AlgorithmIdentifierASN1.set(NULLASN1, 1 + lengthASN1.length + RSAObjectIdentifierASN1.length); // parameters NULL rsaEncryption（1.2.840.113549.1.1.1）の場合はNULL固定）

		return AlgorithmIdentifierASN1.buffer;
	}
}
